import { render, staticRenderFns } from "./Desenvolvimento.vue?vue&type=template&id=5a5f8d83"
import script from "./Desenvolvimento.vue?vue&type=script&lang=js"
export * from "./Desenvolvimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports